/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, EventEmitter, Output} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {URLSearchParams, HttpModule} from '@angular/http';
import {NgModule} from '@angular/core';
import {TabViewModule, PanelModule, DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule,CalendarModule} from 'primeng/primeng';
import {SelectItem} from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';
import {AgentLog} from '../../model/agentlog';
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";
import {Calendar} from "primeng/components/calendar/calendar";
import {DateFormatter} from "@angular/common/src/pipes/intl";
import {SearchModule} from "../../component/search.component";
import {LogCommonTableModule} from "./log_common_table";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS


@Component({

  selector: 'usb-storage-log',
  templateUrl: 'usb_storage_log.html'
})
export class UsbStorageLogComponent implements OnInit {


  page: number;
  max: number;

  search: string;
  field: string;
  start: string;
  end: string;

  totalRecord: number;
  searchIDs: SelectItem[];
  @Output() table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;
  selectedSearchID: string;
  searchText: string;

  pageMax : number = 10;
  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  logType : string[] = ["AL_UsbStorage"];

  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;
  excelIsTrue : boolean = true;

  log_type_items : SelectItem[];
  translate : TranslateServiceForm ;
  
  companyId : any;
  
  ngOnInit() {
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    nDate.setDate(nDate.getDate()-15);
    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd')
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd')
    this.getSetupSearch(0,10, "", "", this.sDate, this.eDate, this.logType);
  }

  constructor(private service: MamAdminService, private logger : Logger, private _translate: TranslateServiceForm) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('ManagementName'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_sourceDevice'), value: 'deviceName'});
    this.dateIsTrue = true;
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.selectedSearchID = event.searchId;

    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }
    this.getSetupSearch(0, this.pageMax, this.searchText, this.selectedSearchID, this.sDate, this.eDate, this.logType);
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getSetupSearch(event.page, event.rows, this.searchText, this.selectedSearchID, this.sDate, this.eDate, this.logType);
    } else {
      this.getSetupSearch(event.page + 1, event.rows, '', '', this.sDate, this.eDate, this.logType);
    }
  }


  getSetupSearch(page: number, max: number, search: string, field: string, start: string, end: string, logType:any): void {
    this.service.getSetUpSearch(page, max, search, field, start, end, logType, this.companyId).subscribe(
      value => {
        this.table_list = value.content;
        this.totalRecord = value.totalElements;

      },
      error => { this.logger.error("-- error : " + error);},
      () => { }
    )
  }

  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    var url = this.service.getUrl() + "/mgr/log/agentlog/setup/excel";
    this.logger.debug(this.selectedSearchID);
    if(!this.selectedSearchID || this.selectedSearchID == "all") {
      url = url + "?start=" + this.sDate + "&end=" + this.eDate + "&setup_type=" + this.logType;
    } else{
      url = url + "?start=" + this.sDate + "&end=" + this.eDate +
      "&search_text=" + this.searchText + "&search_field=" + this.selectedSearchID + "&setup_type=" + this.logType;
    }

    window.open(url);
  }

  searchTextChange(data) {
    if(data == "name") {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = true;
    } else if(data == 'all' || !data)  {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = false;
    } else {
      this.searchTextIsDropBox = false;
      this.searchTextIsUse = true;
    }
  }

}
@NgModule({
  imports: [PanelModule, TabViewModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule, RouterModule,FormsModule,CalendarModule,LogCommonTableModule,SearchModule, SearchDropBoxModule, TranslatePipeMoudle],
  exports: [UsbStorageLogComponent],
  declarations: [UsbStorageLogComponent],
  providers: [MamAdminService],
})
export class UsbStorageLogModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/usb_storage_log.ts